import {ATTACK_LAYER3_URL} from '../constants';
import {AttackLayerThreeWorkerResponse} from '../typings';
import {useFetchWorker} from './use-fetch-worker';

export const useAttackLayerThree = () => {
  return useFetchWorker<AttackLayerThreeWorkerResponse>(ATTACK_LAYER3_URL);
};
